var pug = require("!../../../../pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var pug_debug_filename, pug_debug_line;try {var pug_debug_sources = {"\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fnode_modules\u002F@girder\u002Fhistomicsui\u002Ftemplates\u002Fbody\u002FfrontPage.pug":".h-body-nopad\n"};
;pug_debug_line = 1;pug_debug_filename = "\u002Fopt\u002Fgirder\u002Fgirder\u002Fweb_client\u002Fnode_modules\u002F@girder\u002Fhistomicsui\u002Ftemplates\u002Fbody\u002FfrontPage.pug";
pug_html = pug_html + "\u003Cdiv class=\"h-body-nopad\"\u003E\u003C\u002Fdiv\u003E";} catch (err) {pug.rethrow(err, pug_debug_filename, pug_debug_line, pug_debug_sources[pug_debug_filename]);};return pug_html;};
module.exports = template;


// WEBPACK FOOTER //
// ./~/@girder/histomicsui/templates/body/frontPage.pug